import ProfilePage from '@/views/profile/ProfilePage'

export default function ProfileScreen() {
  return <ProfilePage />
}
